import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Api is a generic REST Api handler. Set your API url first.
 */

@Injectable()
export class Api {
  server:string=environment.apiUrl;
  // server:string='http://127.0.0.1:8000';
  // server:string='http://31.214.168.110/';
  url: string = this.server+'/rest'  
  apiKey: string = 'asdsdjkY$%^';

  constructor(public http: HttpClient) {
  }
  perNum = ['۰|۰|٠', '۱|١|١', '۲|۲|٢', '۳|۳|٣', '۴|۴|٤', '۵|۵|٥', '۶|۶|٦', '۷|۷|٧', '۸|۸|٨', '۹|۹|٩'];
  enNum = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  convertPersianNum ( str : string ){
      str = String(str);
      for(var i = 0 ; i < this.perNum.length ; i++) {
          const reg = new RegExp(this.perNum[i] , 'g' );
          str = str.replace(reg, this.enNum[i]);
      }
      return str;
  }
  get(endpoint: string, params?: any, reqOpts?: any) {
    params['apiKey'] = this.apiKey;
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }

    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    return this.http.get(this.url + '/' + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any,url?:string) {
      
    return this.http.post((url || this.url) + '/' + endpoint+'?apiKey='+this.apiKey, body, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put(this.url + '/' + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    return this.http.delete(this.url + '/' + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.http.patch(this.url + '/' + endpoint, body, reqOpts);
  }
}
